import React from 'react';
import '../styles/global.css';
import '../styles/adPage.css';

const AdPage = () => {
  return (
    <div className="ad-page">
      <div className="ad-content">
        <h1 className="ad-title">Advertisers Center</h1>
        <div className="soon-container">
          <div className="decorative-line"></div>
          <span className="soon-text">SOON</span>
          <div className="decorative-line"></div>
        </div>
      </div>
    </div>
  );
};

export default AdPage; 